<template>
    <main>
        <slide-show :data="$root.banners" :ratio="'0.21'"></slide-show>
        <router-view class="fadeIn"></router-view>

        <transition name="fade">
            <upload v-if="showUpload" @close="showUpload = false" api="/api/upload/uploadLogo" title="简历上传" @confirm="submitData.resumeUrl = $event[0]; request()" :single="true"></upload>
        </transition>
    </main>
</template>
<style lang="less" scoped>
.banner {
    background: url(../assets/images/hr/banner.jpg) center/cover no-repeat;
    height: 500px;
}
</style>

<script>
export default {
    data() {
        return {
            showRequest: false,
            showUpload: false,

            submitData: {
                positionId: undefined,
                resumeUrl: undefined
            },

        }
    },
    methods: {

        request() {
            var that = this;
            ajax.call(this, {
                binding: "submit" + this.submitData.positionId,
                url: "/api/resume/add",
                type: "post",
                data: this.submitData,
            });
        }
    },
    mounted() {
        if (this.$root.groupId) {
            this.$root.getBanner(7);
        }
    }
}
</script>